<template>
    <vue-custom-scrollbar id="workspace-result-designs" class="workspace-module-container">
<!--        v-show="false" Костыль чтобы перерендерить компонент-->
        <div v-show="false">{{lengthUploadedPhotos}}</div>
        <div id="result-designs-container">
            <div v-for="(photo, photoId) in photos" class="project-preview">
                <img class="project-preview-image img-central" :src="getPhotoDataUrl(photoId)" v-on:click="showModal('modal-result-photo', getPhotoDataUrl(photoId))"/>
<!--                <div class="project-preview-text-container collapsable-ellipsis">-->
<!--                    <span class="project-preview-text">Дачный дом</span>-->
<!--                </div>-->
            </div>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import {modalMethods, urlForFileStorage} from "../common";
    // import {renderDesign} from "../../fabric/libs/renderDesign";
    import {imgIsLoadingWhite} from "../ImgIsLoadingWhite";

    export default {
        name: "WorkspaceResultSelectDesign",
        mixins: [urlForFileStorage, modalMethods],
        components: {
            vueCustomScrollbar
        },
        computed:{
            lengthUploadedPhotos(){
                return this.$store.getters["resultImg/LENGTH_UPLOADED_PHOTOS"];
            },
            photos(){
                return this.$store.getters["active/GET_ALL_PHOTO"];
            },
            idDesign(){
                return this.$route.params.designID;
            }
        },
        methods:{
            getPhotoDataUrl(idPhoto){
                const photoSrc = this.$store.getters["resultImg/PHOTO_BASE64_BY_ID"](idPhoto, this.idDesign);
                if(photoSrc){
                    return this.$store.getters[`projectConfiguration/GENERATE_URL`](photoSrc);
                } else {
                    return imgIsLoadingWhite;
                }
            }
        },
        created() {
            this.$store.dispatch('resultImg/LOAD_ALL_DESIGN_PHOTO', {
                idsDesigns: [this.idDesign],
                idsPhotos: Object.keys(this.$store.getters["active/GET_ALL_PHOTO"])
            });
        },
        destroyed() {
            // this.$store.commit('resultImg/CLEAR');
        }
    }
</script>

<style scoped>
    #result-designs-container {
        padding: 50px 0 0 40px;
    }

    #workspace-result-designs {
        background-color: #F2F2F2;
        user-select: none;
    }

    .img-central{
        object-position: center !important;
    }
</style>
